import { render, staticRenderFns } from "./VocDacRes.vue?vue&type=template&id=383a938a&"
import script from "./VocDacRes.vue?vue&type=script&lang=js&"
export * from "./VocDacRes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports